import React from "react";

interface DayInputProps {
  label: string;
  value: string;
  unit?: string;
  onChange: (value: string) => void;
}

const DayInput: React.FC<DayInputProps> = ({ label, value, unit, onChange }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-bold mb-1">{label}</label>
      <div className="flex items-center">
        <input
          type="datetime-local"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-11/12 p-2 border rounded"
        />
        {unit && <span className="ml-2 text-[14px]">{unit}</span>}
      </div>
    </div>
  );
};

export default DayInput;
